import React from 'react';
import ConfirmDangerModal from '../../layout/ReusableComponent/ConfirmDangerModal';

export default function StorageBoxConfirmDeleteModal({ isOpen, item, busy, onClose, onConfirm }) {
  const isFolder = item?.type === 'folder';
  const kind = isFolder ? 'folder' : 'file';

  return (
    <ConfirmDangerModal
      isOpen={isOpen}
      onClose={onClose}
      busy={busy}
      onConfirm={onConfirm}
      title={`Delete ${kind}?`}
      subtitle={item?.name || ''}
      description={
        isFolder
          ? 'This folder and its contents will move to the Bin for 30 days. You can empty the Bin early or restore items before they are permanently removed.'
          : 'This file will move to the Bin for 30 days. You can empty the Bin early before it is permanently removed.'
      }
      confirmLabel="Delete"
      confirmBusyLabel="Deleting…"
    />
  );
}
